<div #origin [class.desktop-menu]="!isMobile" [class.mobile-menu]="isMobile" (click)="onOpenMenu()">
  {{ currentLocale.nameShort }}
</div>

<ng-template #langListContent>
  <div class="menu-content" [class.mobile]="isMobile">
    <div *ngIf="isMobile" class="deck-header">
      <h3>
        <img src="assets/icons/text-bubble-black.svg" width="32" height="32" />
        {{ 'txt_choose_language' | translate }}
      </h3>
      <img (click)="onCloseSwitcher()" class="close" src="assets/checkout/close.svg" alt="" width="" height="" />
    </div>
    <div class="menu-items" [class.mobile]="isMobile">
      <div
        *ngFor="let lang of languagesList"
        class="menu-item"
        [attr.data-item-name]="lang.code"
        (click)="onChangeLocaleCode(lang.code)"
        [class.selected]="currentLocale.code === lang.code"
      >
        {{ lang.name }}
      </div>
    </div>
  </div>
</ng-template>
